import { useSearchParams } from 'react-router';

const SHORTCUTS_PARAM = 'shortcuts';

export const useShortcutsDialog = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const isOpen = searchParams.has(SHORTCUTS_PARAM);

    const open = () =>
        setSearchParams(
            (params) => {
                params.set(SHORTCUTS_PARAM, 'true');

                return params;
            },
            { replace: true },
        );

    const close = () =>
        setSearchParams(
            (params) => {
                params.delete(SHORTCUTS_PARAM);

                return params;
            },
            { replace: true },
        );

    const toggle = () => (isOpen ? close() : open());

    return { isOpen, open, close, toggle };
};
